import { render, staticRenderFns } from "./grocery-list-form.vue?vue&type=template&id=e0af7ac0&"
import script from "./grocery-list-form.vue?vue&type=script&lang=js&"
export * from "./grocery-list-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports